/* eslint class-methods-use-this: 0 */

import _ from 'lodash';
import { computer } from './computations_calcs.js';

/*
 * This point of this is to fill in all the computed values on an order.
 * We are ignoring any values in fields we are computing.
 */
export default class OrderComputations {
  static compute(data) {
    return _.isArray(data) ? data.map(computer) : computer(data);
  }
}
